module.exports = __webpack_public_path__ + "img/sekigahara_photocon_m.77cc28c6.jpg";